import React, { useEffect, useState } from "react";
import "bootstrap/dist/css/bootstrap.min.css";
import axios from "axios";
import { useNavigate, useParams } from "react-router-dom";
import config from '../functions/config';
import { Link } from "react-router-dom";


function PaymentPage() {
  const navigate = useNavigate();
  const { rentalId } = useParams(); // Extract rentalId from the URL parameter
  const [isOpen, setIsOpen] = useState(false);

  const toggleNavbar = () => {
    setIsOpen(!isOpen);
  };
  // Handle Payment Function
  const handlePayment = async () => {
    try {
      const response = await fetch(`${config.BASE_URL}/api/manage-payments/${rentalId}/`, {
        method: "PATCH",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          status: "paid",
        }),
      });

      if (response.ok) {
        alert("Payment processed successfully!");
        navigate("/rentalhistory"); // Navigate to the rental history page after payment
      } else {
        alert("Failed to process payment. Please try again.");
      }
    } catch (error) {
      console.error("Error processing payment:", error);
      alert("An error occurred. Please try again.");
    }
  };;;;;;;;;;;
  return (
    <div>
      {/* Navbar */}
      {/* Navbar */}
      <nav className="navbar navbar-expand-lg navbar-dark bg-dark fixed-top">
      <div className="container-fluid">
        {/* Brand Name */}
        <Link className="navbar-brand" to="/">
          📚 Library 
        </Link>

        {/* Toggle Button */}
        <button
          className="navbar-toggler"
          type="button"
          onClick={toggleNavbar}
          aria-expanded={isOpen}
          aria-label="Toggle navigation"
        >
          <span className="navbar-toggler-icon"></span>
        </button>

        {/* Collapsible Menu */}
        <div className={`navbar-collapse ${isOpen ? "show" : "collapse"}`} id="navbarNav">
          <ul className="navbar-nav ms-auto">
            <li className="nav-item">
              <Link className="nav-link" to="/success">
                Books
              </Link>
            </li>
            <li className="nav-item">
              <Link className="nav-link" to="/userhome">
                Home
              </Link>
            </li>
            <li className="nav-item">
              <Link className="nav-link" to="/profile">
                Profile
              </Link>
            </li>
            <li className="nav-item">
              <Link className="nav-link" to="/rentalhistory">
                Rented Books
              </Link>
            </li>
            <li className="nav-item">
              <Link className="nav-link" to="/purchasehistory">
                Purchase History
              </Link>
            </li>
            <li className="nav-item">
              <Link to="/login" className="btn btn-danger">
                Logout
              </Link>
            </li>
          </ul>
        </div>
      </div>
    </nav>

      {/* Payment Options */}
      <div className="container mt-5 pt-5">
        <h2 className="text-center my-4">Choose Your Payment Method</h2>
        <div className="row justify-content-center">
          <div className="col-md-4">
            <div className="card text-center shadow">
              <div className="card-body">
                <h5 className="card-title">GPay</h5>
                <p className="card-text">Pay quickly and securely using Google Pay.</p>
                <button className="btn btn-primary" onClick={handlePayment}>
                  Pay with GPay
                </button>
              </div>
            </div>
          </div>
          <div className="col-md-4">
            <div className="card text-center shadow">
              <div className="card-body">
                <h5 className="card-title">Card Payment</h5>
                <p className="card-text">Use your credit or debit card for payment.</p>
                <button className="btn btn-success" onClick={handlePayment}>
                  Pay with Card
                </button>
              </div>
            </div>
          </div>
          <div className="col-md-4">
            <div className="card text-center shadow">
              <div className="card-body">
                <h5 className="card-title">Net Banking</h5>
                <p className="card-text">Pay directly from your bank account.</p>
                <button className="btn btn-warning" onClick={handlePayment}>
                  Pay with Banking
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default PaymentPage;
